import Vue from "vue";
import services from "./services";
import VueResource from "vue-resource";
Vue.use(VueResource);

const http = Vue.http;

http.options.root = process.env.VUE_APP_URL_API;
// http.options.root = "http://localhost:5000/api/v2"

Object.keys(services).map(service => {
  services[service] = Vue.resource("", {}, services[service]);
});

const setBearerToken = token => {
  http.headers.common["Authorization"] = `Bearer ${token}`;
};

export default services;
export { http, setBearerToken };
